<template>
  <div>
    <el-input
      clearable
      type="text"
      placeholder="Search profile..."
      v-model="identifier"
      @clear="reset"
      @keyup.enter.native="searchProfile"
    >
      <template #append>
        <el-button @click.native="searchProfile" :disabled="!canSearch">
          <i class="el-icon-search"></i> Search Profile
        </el-button>
      </template>
    </el-input>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'IdentifiersFilter',
  data: () => ({
    identifier: '',
  }),
  computed: {
    canSearch() {
      return this.identifier.trim() !== '';
    },
  },
  watch: {
    identifier(value) {
      if (!value) {
        this.reset();
      }
    },
  },
  methods: {
    apply(filter) {
      get(filter, 'identifier', []);
    },
    reset() {
      this.clearSearch();
    },
    searchProfile() {
      if (this.canSearch) {
        const payload = ['identifier', this.identifier];
        this.$emit('filter', payload);
      }
    },
    clearSearch() {
      this.identifier = '';
      this.$emit('filter', ['identifier', []]);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// IdentifiersFilter.vue?ac1d5a0e